import React, { FC, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { Tabs, Timeline } from 'antd'
import { useSchemaForm } from '../../hooks/use-schema-form'
import { ISchemaEditorProps } from './interface'
import { SchemaContent, SchemaTitle, SchemaWrapper, TabContent } from './styles'

export const SchemaEditor: FC<ISchemaEditorProps> = ({ title, isEdit = false, formData }) => {
  const navigate = useNavigate()
  const handleOnSave = useCallback(() => {
    navigate('/admin/schemas')
  }, [history])

  const { render: SchemaForm } = useSchemaForm({
    onAfterSave: handleOnSave,
    isEdit: isEdit,
    formData: formData,
  })

  return (
    <SchemaWrapper>
      <SchemaTitle>{title}</SchemaTitle>
      <SchemaContent>
        <SchemaForm />
        <Tabs
          type="card"
          items={[
            {
              label: `История изменений`,
              key: 'history_change',
              children: (
                <TabContent>
                  <Timeline>
                    <Timeline.Item>
                      {new Date().toLocaleDateString('ru-ru')} Создание новой структуры
                    </Timeline.Item>
                  </Timeline>
                </TabContent>
              ),
            },
          ]}
        />
      </SchemaContent>
    </SchemaWrapper>
  )
}
